<template>
  <div id="flyer">
    <call />
    <pop-alert />
    <!-- header -->
    <top-bar title="チラシ" backUrl="/"/>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app page="flyer"></footer-app>
      <div class="c-flyer" :class="{'fade-base': true, 'fade': pageFade}">
        <!-- swiper_tab -->
        <div class="swiper-container c-tab-menu js-swiper_tab">
          <div class="swiper-wrapper c-tab-menu__wrap">
            <div class="swiper-slide c-tab-nav__item is-active">スーパー・食品</div>
            <div class="swiper-slide c-tab-nav__item">その他</div>
          </div>
        </div>
        <div class="swiper-container js-swiper_tab_body iframe-wrap" style="max-height: calc(100vh - 214px);">
          <div class="swiper-wrapper">
            <div class="swiper-slide mt-24">
              <div class="p-16" v-if="!foodFlyerUrl">
                現在表示する情報がありません。
              </div>
              <div v-else-if="openFoodExternal">
                <div class="btn-tutorial mx-auto mt-16" style="width: 300px;" @click.prevent="openFoodFlyer(foodFlyerUrl)">
                  スーパー・食品のチラシを開く
                </div>
                <div class="mt-13 text-center" style="color: #999999;">※標準ブラウザで表示</div>
              </div>
              <iframe v-else id="supermarket-iframe" class="iframe nomargin mb-48" :src="foodFlyerUrl" width="100%"></iframe>
            </div>
            <div class="swiper-slide">
              <iframe class="iframe nomargin" :src="scFlyerUrl" width="100%" style="height: 0;"></iframe>
              <div class="list-flyers" v-if="flyers.length > 0" style="padding-bottom: 60px;">
                <div class="c-flyer__wrap bg-white mb-16" v-for="(flyer, index) in flyers" :key="index">
                  <div class="c-flyer__img" v-for="(img, index) in flyer.image" :key="index">
                    <img :src="img" alt="チラシ画像" width="100%"/>
                  </div>
                  <div class="c-flyer__info">
                    <div class="c-flyer__date font-bold mt-13 font-size-14">{{ flyer.title }} {{ flyer.term }}</div>
                  </div>
                </div>
              </div>
              <div class="p-16" v-else>
                現在チラシ情報はございません。
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Tenant } from "../plugin/mixin.js";
import { Common } from "../common/common.js";
import { getShop, getFlyerByShopId } from "../store/firestore";
const $ = window.$;
import Swiper from "swiper";
import PopAlert from "../components/PopAlert.vue";
import firebaseConfig from "../config/firebaseConfig.json";
import dayjs from "dayjs";
import TopBar from "../components/TopBar.vue";

export default Vue.extend({
  name: "Flyer",
  components: {
    'footer-app': Footer,
    PopAlert,
    TopBar
  },
  mixins: [Tenant],
  data(){
    return {
      scFlyerUrl: "",
      foodFlyerUrl: "",
      openFoodExternal: false,
      flyers: [],
    }
  },
  async created() {
    const shopData = await getShop(this.shopId);
    const isStg = firebaseConfig.projectId.indexOf("-stg") != -1;
    if (shopData) {
      this.foodFlyerUrl = shopData.foodFlyerUrl;
      this.openFoodExternal = shopData.openFoodExternal;
      this.scFlyerUrl = isStg ? `https://appstg.a-town-app.com/flyer/?shopId=${this.shopId}&v=5` : `https://a-town-app.com/flyer/?shopId=${this.shopId}&v=5`
      if (this.openFoodExternal) {
        const foodUrl = this.foodFlyerUrl;
        $('#flyer_tab').on('click', function(){
          Common.messageHandlers('show_browser', { url: foodUrl });
        })
      }
      this.flyers = await getFlyerByShopId(this.shopId);
    }
    document.body.style.overflow = 'hidden';
  },
  methods: {
    openFoodFlyer: function(url) {
      Common.messageHandlers('show_browser', { url: url });
    },
    showFlyer(item) {
      const now = this.now;
      const closeAt = item.closeAt ? dayjs(item.closeAt).valueOf() : null;
      const discloseAt = item.discloseAt ? dayjs(item.discloseAt).valueOf() : null;
      if ((closeAt && closeAt < now) || (discloseAt && discloseAt > now)) {
        return false;
      }
      return true;
    }
  },
  mounted() {
    function setCurrentSlide(ele, index) {
      $(".js-swiper_tab .swiper-slide").removeClass("is-active");
      ele.addClass("is-active");
    }
    var swiper_tab = new Swiper('.js-swiper_tab', {
      slidesPerView: 2,
      paginationClickable: true,
      freeMode: true,
      loop: false,
      onTab: function (swiper) {
        var n = swiper_tab.clickedIndex;
      }
    });

    // スーパー・食品のiframeのURLを保持
    const superMarketIframeSrc = $('#supermarket-iframe').attr('src');
    Common.messageHandlers('set_iframe_id', { id: '#supermarket-iframe' });

    if (this.openFoodExternal) {
      const foodUrl = this.foodFlyerUrl;
      $('#flyer_tab').on('click', function(){
        Common.messageHandlers('show_browser', { url: foodUrl });
      })
    }

    $.each(swiper_tab.slides, function (index, val) {
      var ele = $(this);
      ele.on("click", function () {
        if (index == 0) {
          // ネイティブにiframeのidを渡す
          Common.messageHandlers('set_iframe_id', { id: '#supermarket-iframe' });
          // スーパー・食品のiframeを初期化
          $('#supermarket-iframe').attr('src', superMarketIframeSrc);
        }
        setCurrentSlide(ele, index);
        swiper_tab_body.slideTo(index, 500, false);
      });
    });
    var swiper_tab_body = new Swiper('.js-swiper_tab_body', {
      direction: 'horizontal',
      loop: false,
      allowTouchMove: false,
    });

    Common.initDom();
    document.body.style.overflow = 'hidden';
  }
});
</script>
